import debugIt from 'debug'

export const debug = debugIt('mutator-document')
